module.exports = require("@bechtel/client-assets/dist/images/empty-state-commodities.svg");